import SEO from "../components/SEO";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import FooterHome from "../components/FooterHome";
import { StickyOrgNavbar } from "../OrgNavbar";
import { Typography } from "@material-tailwind/react";

export default function PageNotFound() {
  const [message, setMessage] = useState("");
  const location = useLocation();

  useEffect(() => {
  }, []);

  return (
    <>
      <SEO title="Page Not Found" />
      <StickyOrgNavbar />
      <div className="flex justify-center h-screen">
        <Typography variant="h6">
          Page not found
          <p>{message}</p>
          <p>The URL <strong>{location.pathname}</strong> was not found.</p>
        </Typography>
      </div>
      <FooterHome />
    </>
  );
}
